<script>
	import Mapbox from "./map/Mapbox.svelte";
	import Route from "./map/Route.svelte";
	import MapVehicle from "./map/MapVehicle.svelte";
	import Cairns from "./map/Cairns.svelte";
	import createPathStore from "../../stores/path.js";
	import route from "../../stores/route.js";
	import journey from "../../stores/journey.js";
	import profile from "../../stores/profile.js";
	import history from "../../stores/history.js";
	import { map as mapValue } from "../../helpers/color.js";

	export let window;

	const SHOULD_DISPLAY_ROUTE = false;
	const DEFAULT_PROFILE_COLOR = "orangered";

	$: path = $route && createPathStore($route);
	$: profileColor = $profile === undefined ? DEFAULT_PROFILE_COLOR : $profile.color;
	$: isFollowingCurrentVehicle =
		window.props.cairn === undefined && window.props.follow === undefined;

	function opacityForRouteAt(i) {
		return mapValue(i, -1, $history.routes.length, 0.25, 0.75) * 0.75;
	}
</script>

<div>
		<Mapbox {window} center={window.props.center}>
			{#if !window.props.cairn && !window.props.follow}
				{#each $history.routes as route, i}
					<Route
						{route}
						name={`history-${i}`}
						color={profileColor}
						opacity={opacityForRouteAt(i)}
					/>
				{/each}

				{#if $path}
					<Route route={$path} name="path" color={profileColor} />
				{/if}

			{#if SHOULD_DISPLAY_ROUTE && $route}
				<Route route={$route} name="route" color="blue" />
			{/if}
		{/if}

		{#if $journey.location && $profile !== undefined}
			<MapVehicle
				profile={$profile}
				location={$journey.location}
				isFollowing={isFollowingCurrentVehicle}
				shouldAnimateFollow={false}
			/>
		{/if}

		<Cairns />
	</Mapbox>
</div>

<style>
	div {
		width: 100%;
		height: 100%;
	}
</style>
